var PayoutStatuses;
(function (PayoutStatuses) {
    PayoutStatuses["paid"] = "paid";
    PayoutStatuses["failed"] = "failed";
    PayoutStatuses["forwarded"] = "forwarded";
    PayoutStatuses["scheduled"] = "scheduled";
    PayoutStatuses["in_transit"] = "in_transit";
    PayoutStatuses["canceled"] = "canceled";
})(PayoutStatuses || (PayoutStatuses = {}));
var PayoutStatusesSafeNames;
(function (PayoutStatusesSafeNames) {
    PayoutStatusesSafeNames["paid"] = "Paid";
    PayoutStatusesSafeNames["failed"] = "Failed";
    PayoutStatusesSafeNames["forwarded"] = "Forwarded";
    PayoutStatusesSafeNames["scheduled"] = "Scheduled";
    PayoutStatusesSafeNames["in_transit"] = "In Transit";
    PayoutStatusesSafeNames["canceled"] = "Canceled";
})(PayoutStatusesSafeNames || (PayoutStatusesSafeNames = {}));
class Payout {
    constructor(payout) {
        this.id = payout.id;
        this.account_id = payout.account_id;
        this.amount = payout.amount;
        this.bank_account = payout.bank_account;
        this.currency = payout.currency;
        this.delivery_method = payout.delivery_method || 'standard';
        this.description = payout.description;
        this.deposits_at = payout.deposits_at;
        this.fees_total = payout.fees_total;
        this.refunds_count = payout.refunds_count;
        this.refunds_total = payout.refunds_total;
        this.payments_count = payout.payments_count;
        this.payments_total = payout.payments_total;
        this.payout_type = payout.payout_type;
        this.other_total = payout.other_total;
        this.status = payout.status;
        this.metadata = payout.metadata;
        this.created_at = payout.created_at;
        this.updated_at = payout.updated_at;
    }
}

var TerminalStatuses;
(function (TerminalStatuses) {
    TerminalStatuses["connected"] = "connected";
    TerminalStatuses["disconnected"] = "disconnected";
    TerminalStatuses["unknown"] = "unknown";
})(TerminalStatuses || (TerminalStatuses = {}));
var TerminalProviders;
(function (TerminalProviders) {
    TerminalProviders["verifone"] = "verifone";
})(TerminalProviders || (TerminalProviders = {}));
class Terminal {
    constructor(data) {
        this.id = data.id || '';
        this.status = data.status;
        this.account_id = data.account_id || '';
        this.platform_account_id = data.platform_account_id || '';
        this.provider = data.provider || '';
        this.provider_id = data.provider_id || '';
        this.created_at = data.created_at || '';
        this.updated_at = data.updated_at || '';
        this.verified_at = data.verified_at || '';
        this.nickname = data.nickname || '';
    }
}

var AccountType;
(function (AccountType) {
    AccountType["test"] = "test";
    AccountType["live"] = "live";
})(AccountType || (AccountType = {}));
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["created"] = "created";
    AccountStatus["submitted"] = "submitted";
    AccountStatus["information_needed"] = "information_needed";
    AccountStatus["rejected"] = "rejected";
    AccountStatus["enabled"] = "enabled";
    AccountStatus["disabled"] = "disabled";
    AccountStatus["archived"] = "archived";
})(AccountStatus || (AccountStatus = {}));
class SubAccount {
    constructor(subAccount) {
        this.id = subAccount.id;
        this.name = subAccount.name;
        this.account_type = subAccount.account_type;
        this.status = subAccount.status;
        this.currency = subAccount.currency;
        this.platform_account_id = subAccount.platform_account_id;
        this.payout_account_id = subAccount.payout_account_id;
        this.business_id = subAccount.business_id;
        this.application_fee_rates = subAccount.application_fee_rates;
        this.processing_ready = subAccount.processing_ready;
        this.payout_ready = subAccount.payout_ready;
        this.related_accounts = subAccount.related_accounts;
        this.created_at = subAccount.created_at;
        this.updated_at = subAccount.updated_at;
    }
}

export { Payout as P, SubAccount as S, Terminal as T };
